import React from 'react';

interface IconChatEmptyProps {
  className?: string;
}

const IconChatEmpty: React.FC<IconChatEmptyProps> = ({ className }) => {
  // Inline SVG inspired by the Figma asset (stack of speech bubbles + sparkles).
  return (
    <svg
      className={className ?? 'w-[120px] h-[120px]'}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="60" cy="60" r="60" fill="currentColor" opacity="0.04" />
      <path
        d="M40 49a10 10 0 0 1 10-10h28a10 10 0 0 1 10 10v18a10 10 0 0 1-10 10h-9.7l-7.4 6.6a1.5 1.5 0 0 1-2.5-1.1V77H50a10 10 0 0 1-10-10V49z"
        fill="currentColor"
        opacity="0.35"
      />
      <circle cx="56" cy="58" r="2.4" fill="white" />
      <circle cx="64" cy="58" r="2.4" fill="white" />
      <circle cx="72" cy="58" r="2.4" fill="white" />
      <path
        d="M30 44l2 2 2-2-2-2-2 2zM92 36l1.5 1.5L95 36l-1.5-1.5L92 36zM26 80l2 2 2-2-2-2-2 2zM98 70l2 2 2-2-2-2-2 2z"
        fill="currentColor"
        opacity="0.4"
      />
    </svg>
  );
};

export default IconChatEmpty;
